import React,{useEffect,useRef,useState} from 'react';
import {createPortal} from 'react-dom';
import {provinceWarRequest} from '../ProvinceWar/api';
import './NpcDialogue.css';

export const NPC_LINES={
 iruka:'สุดยอดนินจา ต้องรู้จักช่วยเหลือหมู่บ้าน ฉันว่าคุณก็มีแววนะ ลองเข้าร่วมศึกชิงสุดยอดแห่งแคว้นดูไหมล่ะ? ฉันช่วยได้นะ',
 closed:'ใจร้อนเสียจริงไอ้เจ้าคนนี้ ฮ่าๆ มาลองใหม่ตอน 19:00 - 23:00 สิ',
 decline:'ฮ่าๆ เจ้านี่ขี้เกียจเหมือนเจ้านารูโตะเลย เอาเถอะ อยากน้อยนารูโตะก็ยังไม่ใช่เศษสวะอย่างคุณ ฮ่าๆ',
 teuchi:'ตอนนี้ฉันยังไม่ว่างหาอะไรให้นายทำหรอกนะ ขายราเมนวันๆก็ยุ่งพอแล้ว'
};
export function NpcDialogue({npc,onClose,onEnter,request=provinceWarRequest}:{npc:{id:string;name:string};onClose:()=>void;onEnter:(room:{selfId:number;village:number})=>void;request?:typeof provinceWarRequest}) {
 const [message,setMessage]=useState(npc.id==='iruka'?NPC_LINES.iruka:NPC_LINES.teuchi),[busy,setBusy]=useState(false);
 const live=useRef(true),pending=useRef(false),root=useRef<HTMLElement>(null);
 useEffect(()=>{live.current=true;const previous=document.activeElement as HTMLElement|null;root.current?.focus();const key=(e:KeyboardEvent)=>{
  if(e.key==='Escape'){e.preventDefault();e.stopPropagation();if(!pending.current)onClose();}
  if(e.key==='Tab'){const buttons=Array.from(root.current?.querySelectorAll<HTMLButtonElement>('button:not(:disabled)')??[]);if(!buttons.length)return;const index=buttons.indexOf(document.activeElement as HTMLButtonElement);e.preventDefault();buttons[(index+(e.shiftKey?-1:1)+buttons.length)%buttons.length].focus();}
 };document.addEventListener('keydown',key,true);return()=>{live.current=false;document.removeEventListener('keydown',key,true);if(previous?.isConnected)previous.focus();};},[onClose]);
 const join=async()=>{if(pending.current)return;pending.current=true;setBusy(true);try{
  const status=await request({action:'npc'});if(!live.current)return;
  if(!status.canEnter){setMessage(NPC_LINES.closed);return;}
  const result=await request({action:'enter'});if(!live.current)return;
  if(result?.admitted)onEnter({selfId:result.selfId,village:result.village});
  else setMessage(NPC_LINES.closed);
 }catch(e){if(live.current){const error=(e as Error).message;setMessage(/19:00|หมดเวลา/.test(error)?NPC_LINES.closed:error);}}
 finally{pending.current=false;if(live.current)setBusy(false);}};
 return createPortal(<div className="npc-dialogue-backdrop" onPointerDown={e=>e.stopPropagation()}>
  <section ref={root} tabIndex={-1} className="npc-dialogue" role="alertdialog" aria-modal="true" aria-labelledby="npc-dialogue-name" aria-describedby="npc-dialogue-text" aria-busy={busy}>
   <header id="npc-dialogue-name">{npc.name}</header>
   <div id="npc-dialogue-text" className="npc-dialogue-text">{message}</div>
   <div className="npc-dialogue-options">
    {npc.id==='iruka'&&<><button disabled={busy} onClick={join}>เข้าร่วม</button><button disabled={busy} onClick={()=>setMessage(NPC_LINES.decline)}>ไม่ล่ะ</button></>}
    <button disabled={busy} onClick={onClose}>จบบทสนทนา</button>
   </div>
  </section>
 </div>,document.body);
}
